import { RulebookDashboardComponent } from './rulebook-dashboard/rulebook-dashboard.component';
import { LinkedUpdatesComponent } from './../shared/linked-updates/linked-updates.component';
import { RuleTreeComponent } from './rule-tree/rule-tree.component';
import { RuleHierarchyComponent } from './rule-hierarchy/rule-hierarchy.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/services/auth/auth.guard';
import { LibraryComponent } from './library.component';
import { ChangeDetailComponent } from '../change-detail/change-detail.component';
import { PlanType } from 'src/app/core/enums/user';
import { NewRulebooksComponent } from '../shared/new-rulebooks/new-rulebooks.component';
import { NewRulebookPrimengComponent } from '../shared/new-rulebook-primeng/new-rulebook-primeng.component';
import { ReportingTemplatesComponent } from './reporting-templates/reporting-templates.component';

export const LibraryRoutes: Routes = [{
  path: '',
  component: LibraryComponent,
  canActivate: [AuthGuard],
  data: { disabledForPlanType: PlanType.Suisse },

  children: [
    { path: '', redirectTo: '', pathMatch: 'full' },
    
    {
      path: 'rule-detail',
      component: ChangeDetailComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'open-linked-updates',
      component: LinkedUpdatesComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'actioned-linked-updates',
      component: LinkedUpdatesComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'rule-hierarchy',
      component: RuleHierarchyComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'rule-tree',
      component: RuleTreeComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'rulebook-dashboard',
      component: RulebookDashboardComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    // {
    //   path: 'rule-book',
    //   component: NewRulebooksComponent,
    //   data: { disabledForPlanType: PlanType.Suisse }
    // },
    // {
    //   path: 'rule-book/:rulebook',
    //   component: NewRulebooksComponent,
    //   data: { disabledForPlanType: PlanType.Suisse }
    // },
    // {
    //   path: 'rule-book/:rulebook/:id',
    //   component: NewRulebooksComponent,
    //   data: { disabledForPlanType: PlanType.Suisse }
    // },
    // {
    //   path: 'rule-book/:rulebook/:id/:rulebookName',
    //   component: NewRulebooksComponent,
    //   data: { disabledForPlanType: PlanType.Suisse }
    // },
    {
      path: 'rule-book',
      component: NewRulebookPrimengComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'rule-book/:rulebook',
      component: NewRulebookPrimengComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'rule-book/:rulebook/:id',
      component: NewRulebookPrimengComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    {
      path: 'rule-book/:rulebook/:id/:rulebookName',
      component: NewRulebookPrimengComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    },
    // /library/reporting-templates/Template/73
    {
      path: 'reporting-templates/:reporting-templates/:id',
      component: ReportingTemplatesComponent,
      data: { disabledForPlanType: PlanType.Suisse }
    }
  ]
}];
